import {environment} from "src/environments/environment";
import {EnvironmentPlatform} from "src/environments/environment-template";

/**
 * Enum representing the platform being used, which is sent to Adyen.
 */
export enum AdyenChannel {
    ANDROID = 'Android',
    IOS = 'iOS',
    WEB = 'Web'
}

/**
 * Maps the current application platform to the corresponding Adyen platform.
 * @returns {AdyenChannel} The matching Adyen platform.
 */
export function getAdyenChannel(): AdyenChannel {
    switch (environment.PLATFORM) {
        case EnvironmentPlatform.IOS:
            return AdyenChannel.IOS;
        case EnvironmentPlatform.AND:
            return AdyenChannel.ANDROID;
        case EnvironmentPlatform.WEB:
            return AdyenChannel.WEB;
    }
}
